var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Events } from '@type-r/models';
import * as React from 'react';
import { getAppHref } from './common';
export var Link = function (_a) {
    var _b = _a.href, href = _b === void 0 ? undefined : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, children = _a.children, _d = _a.onClick, onClick = _d === void 0 ? undefined : _d, _e = _a.anchor, anchor = _e === void 0 ? undefined : _e, _f = _a.params, params = _f === void 0 ? undefined : _f, _g = _a.returnUrl, returnUrl = _g === void 0 ? false : _g, _h = _a.onMouseDown, onMouseDown = _h === void 0 ? undefined : _h, props = __rest(_a, ["href", "disabled", "children", "onClick", "anchor", "params", "returnUrl", "onMouseDown"]);
    if (returnUrl) {
        params = __assign({}, params, { returnUrl: "" + window.location.pathname + window.location.search });
    }
    var url = href;
    if (params) {
        url += "?" + new URLSearchParams(params);
    }
    return (React.createElement("a", __assign({ href: url || '#' }, props, { onMouseDown: onMouseDown, onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (disabled)
                return false;
            onClick && onClick(e);
            href && Events.trigger('navigate', href, anchor, params);
        } }), children));
};
export var AppLink = function (_a) {
    var href = _a.href, children = _a.children, rest = __rest(_a, ["href", "children"]);
    var appHref = getAppHref(href);
    return (React.createElement(Link, __assign({ href: appHref }, rest), children));
};
//# sourceMappingURL=link.js.map